export default {
    navigationBackground: '#010101',
    primary: '#0e75dd',
    primary2: '#5cc0fe',
    primary3: '#ACDACF',
    primary4: '#E8F5F2',
    secondary: '#435a62',
    accent: '#0e75dd',
    accent2: '#EF935E',
    accent3: '#F7C7AC',
    accent4: '#FDF0E8',
    primaryhighlight: '#E8F5F2',
    primaryhighlight2: '#5cc0fe',
    error: '#FF5252',
    info: '#FDF0E8',
    success: '#4CAF50',
    warning: '#FFC107',
    textgrey: '#cccccc',
    text1: '#808080',
    text4: '#F2F2F2',
    lighttext: '#ffffff'
};